'use strict';

import entryPointTemplate from './entryPoint.html';

var entryPointController = function ($controller, $translate, $location, $state, workflowService) {
    var vm = this;
    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function() {

        workflowService.getOrCreateTicket(vm.listId, vm.studyId, $location.search()).then(ticket => {
            var currentLanguage = $translate.use();
            if (currentLanguage !== ticket.language) $translate.use(ticket.language);

            if (ticket.status === 'InProgress') {
                workflowService.goToFirstActiveStep (ticket.id);
            } else {
                $state.go('ticketCompleted');
            }
        });
    }
}

entryPointController.$inject = [ '$controller', '$translate', '$location', '$state', 'workflowService' ];

export var entryPointComponent = {
    name: 'entryPoint',
    template: entryPointTemplate,
    bindings: {
        listId: '@',
        studyId: '@'
    },
    controller: entryPointController,
    controllerAs: 'vm'
};

export var entryPointRoute = {
    name: 'entryPoint',
    url: '/entrypoint/{listId}/{studyId}',
    component: 'entryPoint',
    resolve: {
        listId: ['$transition$', function ($transition$) {
            return $transition$.params().listId;
        }],
        studyId: ['$transition$', function ($transition$) {
            return $transition$.params().studyId;
        }]
    }
};